export default function () {
  if (document.querySelectorAll('.variant-block-section-image').length) {
    import(
    /* webpackChunkName: "content-blocks" */
    './content-blocks').then(function (module) {
      return module.default();
    }) // eslint-disable-next-line no-unused-vars
    .catch(function (error) {
      return 'An error occurred while loading content-blocks';
    });
  }
}